import { render } from "./MediaCarousel.vue?vue&type=template&id=3c5aa25a&scoped=true"
import script from "./MediaCarousel.vue?vue&type=script&lang=js"
export * from "./MediaCarousel.vue?vue&type=script&lang=js"

import "./MediaCarousel.vue?vue&type=style&index=0&id=3c5aa25a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5aa25a"]])

export default __exports__